module.exports = __webpack_public_path__ + "media/caution.db2e56e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/icons/caution.svg
// module id = 835
// module chunks = 0